import classNames from 'classnames';
import React from 'react';
import QRCode from 'react-qr-code';

import styles from './index.module.scss';

export default function AppQRCode({
  qrCode,
  width,
  wrapperClassName,
}: {
  qrCode: string;
  width: number;
  wrapperClassName?: string;
}) {
  return (
    <div className={classNames(styles.root, wrapperClassName)}>
      <QRCode
        size={width}
        level="L"
        bgColor="#FFFFFF"
        fgColor="#000000"
        className={styles.qrCode}
        value={qrCode}
      />
    </div>
  );
}
